import { Host, h } from '@stencil/core';
import { isMobile } from '../../../utils/utils';
export class AibaAccordion {
  constructor() {
    this.accordionData = undefined;
    this.arrowDownIcon = undefined;
    this.arrowUpIcon = undefined;
    this.handlers = undefined;
    this.header = undefined;
    this.toggle = false;
    this.toggleState = false;
    this.isAccordion = true;
    this.styles = undefined;
    this.classes = undefined;
    this.defaultAccordion = undefined;
    this.fireHandleClick = false;
  }
  handdleClick(event) {
    var _a;
    this.toggle = !this.toggle;
    (_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleToggleAccordian(event);
  }
  handleClickToggle(event) {
    var _a;
    this.toggleState = !this.toggleState;
    (_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleToggleAccordian(event);
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.handleAccordionWillLoad) {
      const { fireHandleClick, toggleState, isAccordion } = await this.handlers.handleAccordionWillLoad();
      this.fireHandleClick = fireHandleClick;
      this.toggleState = toggleState;
      this.isAccordion = isAccordion;
    }
  }
  render() {
    if (!this.defaultAccordion && !this.fireHandleClick) {
      if (!this.isAccordion) {
        this.toggle = true;
      }
      if (!isMobile()) {
        this.toggle = true;
      }
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", null, h("div", { class: `accordion__header ${!this.isAccordion ? 'open' : ''} ${this.toggle ? 'open' : ''} ${this.isAccordion && this.toggleState ? 'open' : ''} `, "aria-label": 'accordion', onClick: event => {
        if (!this.fireHandleClick) {
          this.defaultAccordion ? this.handdleClick(event) : isMobile() && this.handdleClick(event);
        }
        this.isAccordion && this.fireHandleClick && this.handleClickToggle(event);
      }, tabIndex: 0 }, h("h2", { class: "accordion__header-h2" }, this.header)), h("div", { class: `accordion__body ${!this.isAccordion ? 'open' : ''} ${this.toggle ? 'open' : ''} ${this.isAccordion && this.toggleState ? 'open' : ''}`, ref: el => (this.contentWrapperRef = el) }, h("div", { class: "accordion__body__element" }, this.accordionData())))));
  }
  static get is() { return "aiba-accordion"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-accordion.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-accordion.css"]
    };
  }
  static get properties() {
    return {
      "accordionData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "accordion-data",
        "reflect": false
      },
      "arrowDownIcon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arrow-down-icon",
        "reflect": false
      },
      "arrowUpIcon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arrow-up-icon",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "header": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "header",
        "reflect": false
      },
      "toggle": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "toggle",
        "reflect": false,
        "defaultValue": "false"
      },
      "isAccordion": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-accordion",
        "reflect": false,
        "defaultValue": "true"
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "defaultAccordion": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "default-accordion",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "toggleState": {},
      "fireHandleClick": {}
    };
  }
}
//# sourceMappingURL=aiba-accordion.js.map
